<template>
    <div style="background-color: #f0f6fa;">
        <div style="position: relative;">
            <img src="@/images/productBanana.png" style="width: 100vw;height: 1.5734vw * 30.21;">
            <div class="topTitle">
                见心心理健康服务平台
            </div>
            <div class="topText">
                “见心心理健康服务平台”
                是基于心理学、云计算、物联网、人工智能以及大数据等技术打造的科学心育智能平台，主要从积极预防、心理辅导、优化提质三个层面出发，面向教育管理者、老师、学生、家长等群体用户，构建服务于教育主管部门、学校、家庭、社会四位于一体的完整闭环科学心育体系。
            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.5625vw">
                <div style="margin-bottom:0.5208vw;padding-top:3.5938vw;">
                    关于见心
                </div>
                <div style="font-weight: 400;font-size: 0.7292vw;color: #7ED0FF;">
                    About FOHEART
                </div>
            </div>
            <div class="box2Css">
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">

                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg1.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            心理健康管理平台
                        </div>
                        <div class="boxText">
                            PC管理端/手机端
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">

                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg2.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            见心管家
                        </div>
                        <div class="boxText">
                            PC管理端
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">

                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg3.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            校园心理辅导管理系统
                        </div>
                        <div class="boxText">
                            PC管理端
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.5625vw">
                <div style="margin-bottom:0.5208vw;padding-top:3.5938vw;">
                    见心大数据平台
                </div>
                <div style="font-weight: 400;font-size: 0.7292vw;color: #7ED0FF;">
                    Big data platform
                </div>
            </div>
            <div class="box2Css">
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">

                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg4.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            见心自助宣教系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">
                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg5.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            见心成长训练系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">
                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg6.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            学习障碍干预系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.5625vw">
                <div style="margin-bottom:0.5208vw;padding-top:3.5938vw;">
                    统计报表
                </div>
                <div style="font-weight: 400;font-size: 0.7292vw;color: #7ED0FF;">
                    Statistical reports
                </div>
            </div>
            <div class="box2Css">
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">

                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg7.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            多通道身心放松训练系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">
                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg8.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            见心情绪释压系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">
                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg9.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            见心多维互动减压系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.5625vw">
                <div style="margin-bottom:0.5208vw;padding-top:3.5938vw;">
                    共享资源
                </div>
                <div style="font-weight: 400;font-size: 0.7292vw;color: #7ED0FF;">
                    Shared resources
                </div>
            </div>
            <div class="box2Css">
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">

                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg10.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            团体身心放松训练系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">
                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg11.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            家校共育课堂
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/boxItem.png" style="width: 23.75vw;height: 26.1458vw;">
                    <div class="boxItemCss">
                        <div style="height: 14.5833vw;">
                            <img src="@/images/productImg12.png" style="width: 100%;max-height: 14.5833vw;">
                        </div>
                        <div class="boxTitle">
                            3D电子沙盘系统
                        </div>
                        <div class="boxText">
                            安卓一体机
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 2.6042vw;"></div>

    </div>
</template>

<script>
export default {
    name: 'productPage',
    data() {
        return {

        }
    }
}
</script>

<style lang="less" scoped>
.boxOne {
    width: 72.9167vw;
    margin: 0 auto;
    min-height: 33.5938vw;
    background: #fff;
    border-radius: 1.0417vw;
    margin-top: 2.083vw;
}

.TitleCss {
    margin: 0 auto;
    text-align: center;
    // margin-top: 7.4479vw;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.875vw;
    color: #0093E8;
}


.box2Css {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

}

.boxItemCss {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 23.75vw;
    height: 26.1458vw;
    position: absolute;
    left: 0;
    top: 0;
}

.boxTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 1.4583vw;
    color: #323232;
    margin-top: 1.0417vw;
    margin-bottom: 0.5208vw;
}

.boxText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 300;
    font-size: 1.0417vw;
    color: #666666;
}

.topTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.875vw;
    color: #FFFFFF;
    position: absolute;
    left: 17.0833vw;
    top: 10.1563vw;
}

.topText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 1.0417vw;
    color: #FFFFFF;
    line-height: 1.875vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    position: absolute;
    left: 17.0833vw;
    top: 14.1667vw;
    width: 39.74vw;
}
</style>